<template>
  <div>
    <template v-for="(item, index) in servicesStore.servicesDescList" :key="'servicesDesc' + index">
      <egg-description
        :eggImgObj="{ componentName: 'services', imgName: item.image.imgName, imgFormat: item.image.imgFormat, position: index % 2 === 0 ? 'left' : 'right' }"
        :starBackgroundLeftObj="starBackgroundLeftObj(index)"
        :starBackgroundRightObj="starBackgroundRightObj(index, servicesStore.servicesDescList.length)"
        textMode="text"
        :label="item.label"
        :description="item.description"
        labelColor="#603813"
        descFontSize="small"
        class="pb-24"
      />
    </template>
  </div>
</template>


<script setup lang="ts">
import { useServicesStore } from "@/stores/services";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const servicesStore = useServicesStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const starBackgroundLeftObj = (index) => {
  if (index == 4) return { componentName: "shared", imgName: "starGroupIconBrownLeft", imgFormat: "svg", bottom: "-60%" };
};

const starBackgroundRightObj = (index, totalLength) => {
  if (index == 2) return { componentName: "shared", imgName: "starGroupIconBrownRight", imgFormat: "svg", top: "-10%" };
  else if (index == totalLength - 1) return { componentName: "shared", imgName: "starGroupIconBrownLeft", imgFormat: "svg", top: "-20%" };
};
</script>